import type { Location } from 'modules/core/lib/navigation/types'

export const navigation = {
  path: 'salary-advance',
  children: {
    requests: {
      size: 'full',
      path: 'requests',
    },
  },
} as const satisfies Location
